/* GOOGLE_MAPS_DISABLED - restore when API key available */
// /// <reference types="@types/google.maps" />
/* END GOOGLE_MAPS_DISABLED */
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { MasterModel } from '../../../../../master/models/master.model';
/* GOOGLE_MAPS_DISABLED - restore when API key available */
// import { GoogleMapsLoaderService } from '../../../services/google-maps-loader.service';
/* END GOOGLE_MAPS_DISABLED */
import { SlugOnboardingDialogComponent } from './slug-onboarding-dialog.component';

const SLUG_ONBOARDING_KEY = 'slug_onboarding_seen';

@Component({
    selector: 'app-location-general-section',
    templateUrl: './location-general-section.component.html',
    styleUrls: ['./location-general-section.component.css'],
    standalone: false
})
export class LocationGeneralSectionComponent implements OnInit {
  @Input() formGroup!: UntypedFormGroup;
  @Input() isEditMode = false;
  @Input() isSaving = false;
  @Input() isLoadingCatalogs = false;

  @Input() countriesOptions: MasterModel[] = [];
  @Input() provincesOptions: MasterModel[] = [];
  @Input() municipalitiesOptions: MasterModel[] = [];
  @Input() locationStatusesOptions: MasterModel[] = [];
  @Input() merchantLocationCategoriesOptions: MasterModel[] = [];
  @Input() timeZonesOptions: MasterModel[] = [];
  @Input() currencyCodesOptions: MasterModel[] = [];

  @Output() save = new EventEmitter<any>();
  @Output() countryChanged = new EventEmitter<string>();
  @Output() stateChanged = new EventEmitter<string>();

  /* GOOGLE_MAPS_DISABLED - restore when API key available */
  // @ViewChild('googleMapsInput') googleMapsInputRef!: ElementRef;
  //
  // googleMapsReady = false;
  // googleMapsError = false;
  /* END GOOGLE_MAPS_DISABLED */

  constructor(
    /* GOOGLE_MAPS_DISABLED - restore when API key available */
    // private googleMapsLoader: GoogleMapsLoaderService,
    // private ngZone: NgZone,
    /* END GOOGLE_MAPS_DISABLED */
    private dialog: MatDialog
  ) { }

  ngOnInit(): void { }

  onSlugClick(): void {
    if (!localStorage.getItem(SLUG_ONBOARDING_KEY)) {
      this.openSlugOnboarding();
    }
  }

  openSlugOnboarding(): void {
    this.dialog.open(SlugOnboardingDialogComponent, { width: '520px', maxWidth: '96vw', disableClose: false });
    localStorage.setItem(SLUG_ONBOARDING_KEY, '1');
  }

  /* GOOGLE_MAPS_DISABLED - restore when API key available */
  // ngAfterViewInit(): void {
  //   this.googleMapsLoader.load()
  //     .then(() => {
  //       this.googleMapsReady = true;
  //       this.initPlacesAutocomplete();
  //     })
  //     .catch(() => {
  //       this.googleMapsError = true;
  //     });
  // }
  //
  // private initPlacesAutocomplete(): void {
  //   if (!this.googleMapsInputRef) return;
  //
  //   const autocomplete = new google.maps.places.Autocomplete(
  //     this.googleMapsInputRef.nativeElement,
  //     { types: ['address'], fields: ['address_components', 'geometry', 'formatted_address'] }
  //   );
  //
  //   autocomplete.addListener('place_changed', () => {
  //     this.ngZone.run(() => {
  //       const place = autocomplete.getPlace();
  //       if (!place || !place.address_components) return;
  //       this.fillFormFromPlace(place);
  //     });
  //   });
  // }
  //
  // private fillFormFromPlace(place: google.maps.places.PlaceResult): void {
  //   const components = place.address_components || [];
  //   const get = (type: string) => {
  //     const c = components.find((a: google.maps.GeocoderAddressComponent) => a.types.includes(type));
  //     return c ? c.long_name : '';
  //   };
  //   const getShort = (type: string) => {
  //     const c = components.find((a: google.maps.GeocoderAddressComponent) => a.types.includes(type));
  //     return c ? c.short_name : '';
  //   };
  //
  //   const streetNumber = get('street_number');
  //   const route = get('route');
  //   const addressLine1 = route ? `${route}${streetNumber ? ', ' + streetNumber : ''}` : '';
  //   const city = get('locality') || get('administrative_area_level_2') || get('postal_town');
  //   const state = get('administrative_area_level_1');
  //   const countryCode = getShort('country');
  //   const postalCode = get('postal_code');
  //   const lat = place.geometry && place.geometry.location ? place.geometry.location.lat() : null;
  //   const lng = place.geometry && place.geometry.location ? place.geometry.location.lng() : null;
  //
  //   this.formGroup.patchValue({
  //     addressLine1,
  //     city,
  //     state,
  //     postalCode,
  //     ...(lat !== null && { latitude: lat }),
  //     ...(lng !== null && { longitude: lng }),
  //   });
  //
  //   if (countryCode) {
  //     const countryOption = this.countriesOptions.find(
  //       o => o.id === countryCode || (o as any).code === countryCode
  //     );
  //     if (countryOption) {
  //       this.formGroup.patchValue({ countryCode: countryOption });
  //       this.countryChanged.emit(countryCode);
  //     }
  //   }
  // }
  /* END GOOGLE_MAPS_DISABLED */

  onSave(): void {
    if (this.formGroup.invalid) {
      this.markFormGroupTouched(this.formGroup);
      return;
    }

    const formValue = this.formGroup.value;

    const dataToSave: any = {
      ...formValue,
      merchantLocationId: formValue.merchantLocationId || null,
      countryCode: formValue.countryCode && formValue.countryCode.id ? formValue.countryCode.id : formValue.countryCode,
      currencyCode: formValue.currencyCode && formValue.currencyCode.id ? formValue.currencyCode.id : formValue.currencyCode,
      timeZoneId: formValue.timeZoneId && formValue.timeZoneId.id ? formValue.timeZoneId.id : formValue.timeZoneId,
      statusMerchantLocationId: formValue.statusMerchantLocationId && formValue.statusMerchantLocationId.id
        ? parseInt(formValue.statusMerchantLocationId.id, 10)
        : (formValue.statusMerchantLocationId ? parseInt(formValue.statusMerchantLocationId, 10) : null),
      merchantLocationCategoryId: formValue.merchantLocationCategoryId && formValue.merchantLocationCategoryId.id
        ? parseInt(formValue.merchantLocationCategoryId.id, 10)
        : (formValue.merchantLocationCategoryId ? parseInt(formValue.merchantLocationCategoryId, 10) : null),
      state: formValue.state && formValue.state.display ? formValue.state.display : formValue.state,
      city: formValue.city && formValue.city.display ? formValue.city.display : formValue.city
    };

    this.save.emit(dataToSave);
  }

  onCountryChange(country: any): void {
    this.formGroup.patchValue({ state: null, city: null });
    const countryCode = country && country.id ? country.id : country;
    this.countryChanged.emit(countryCode);
  }

  onStateChange(state: any): void {
    this.formGroup.patchValue({ city: null });
    const stateCode = state && state.id ? state.id : state;
    this.stateChanged.emit(stateCode);
  }

  generateSlugFromName(): void {
    const nameControl = this.formGroup.get('name');
    const slugControl = this.formGroup.get('slug');

    if (nameControl && slugControl && nameControl.value) {
      slugControl.setValue(this.generateSlug(nameControl.value));
      slugControl.markAsTouched();
    }
  }

  private generateSlug(text: string): string {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control) {
        control.markAsTouched();
        if (control instanceof UntypedFormGroup) {
          this.markFormGroupTouched(control);
        }
      }
    });
  }
}
